import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings/webhooks/')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings/webhooks/outbound',
    })
  },
})
